import { CHECK_TYPE_LABELS } from "./getConstants";

export function formatCheckType(type = "") {
  const key = type?.toLowerCase();
  if (CHECK_TYPE_LABELS[key]) return CHECK_TYPE_LABELS[key];

  return type
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
